import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import { globalImportUrl } from '../core/request';
/**
 * Ride Filters
 * Get all available filters and sorts that can be passed to the ride API endpoint corresponding to the library type. If one or more fitness disciplines are provided, then return only filters that are valid for at least one of those fitness disciplines. For filters with "user_specific" as false, it is guaranteed that searching the endpoint corresponding to the provided "library_type" with only a value of this filter and the provided "fitness_discipline" as arguments will return at least one ride.
 * @param libraryType Which library to search.
 * @param fitnessDiscipline Type of ride to return filters for. If multiple are provided, then return all filters that are valid for any of those fitness disciplines. If any fitness discipline is provided that isn't allowed by the platform, this returns an error. If not provided, the default value is all fitness disciplines allowed by the platform based on the Peloton-Platform header. Multiple values should be separated by comma. Cannot be used in conjunction with 'browse_category' Include Body Focus collection type filter in response for on_demand ride type, circuit fitness_discipline.
 * @param browseCategory The Browse Category slug to search for ride filters under.
 * Cannot be used in conjunction with fitness_discipline
 * @param pelotonPlatform Platform the endpoint is called on. This may hide information from the response (class types, fitness disciplines, classes of certain fitness disciplines, etc.) that should not display on this platform. If this has any other effect on the endpoint, it will be noted in the description.
 *
 * @param includeIconImages True/False toggle to include new icon image urls in the response.  The currently supported filters with images affected by this toggle are: counted in, weights yes, weights no,  bookmarked, and taken by me. Note, this parameter will have no effect on the instructor images.  Instructor images  will be returned by the api regardless of the value of this parameter.
 * @returns RideFilterResponse A ride filter response
 * @throws ApiError
 */

export var getRideFilters = function getRideFilters(api, libraryType, fitnessDiscipline, browseCategory, pelotonPlatform, includeIconImages) {
  var options = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
  var localVarPath = "/api/ride/filters";
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof libraryType !== 'undefined') {
    localVarQueryParameter['library_type'] = libraryType;
  }

  if (typeof fitnessDiscipline !== 'undefined') {
    localVarQueryParameter['fitness_discipline'] = fitnessDiscipline;
  }

  if (typeof browseCategory !== 'undefined') {
    localVarQueryParameter['browse_category'] = browseCategory;
  }

  if (typeof includeIconImages !== 'undefined') {
    localVarQueryParameter['include_icon_images'] = includeIconImages;
  }

  localVarHeaderParameter['Peloton-Platform'] = String(pelotonPlatform);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Collection Filters
 * Get all available filters and sorts that can be passed to the class group API endpoint. For filters with "user_specific" as false, it is guaranteed that it will return at least one ride. If user is not logged in, "user_specific" filters will not be returned.
 * @param pelotonClientDate Timestamp on the user's device in ISO-8601 format. It is recommended to add the IANA
 * time zone in addition to the time zone offset. i.e. the full TZD would be "+05:30[Asia/Kolkata]"
 * See "TZ database name" for IANA zone:
 * https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
 *
 * @param classGroupId The class group id
 * @param acceptLanguage Accept language(s) that the user choose on the device.
 * If not included or unsupported, the value will default to en-US.
 * Can be weighted with the quality value syntax.
 *
 * Examples:
 * Accept-Language: de
 * Accept-Language: en-US, en;q=0.5
 * Accept-Language: de-DE, de;q=0.9, en-US, en;q=0.7
 *
 * Specification: https://tools.ietf.org/html/rfc7231#section-5.3.5
 *
 * @param pelotonClientDetails Client details that clients send to API for sending events to
 * Segment.
 *
 * These properties are sent as a mapping of key value pairs, where the
 * key is each expected Segment property name and its value is the client's
 * property value.
 *
 * Refer to
 * https://docs.google.com/spreadsheets/d/1NkMmgAqDERhzLJJ7E7gbgX2Mz8OBpSUOJ1n2xJS_2RI/edit#gid=1066590696
 * for more details on Segment events and schema.
 *
 * This mapping is first JSON-serialized and then base64-encoded. The
 * base64-encoding is set as the header's value.
 *
 * Below we outline some examples:
 *
 * Web Client
 * ~~~~
 * 'Browser': 'Chrome',
 * 'Form Factor': 'Desktop',
 * 'Operating System': 'Windows',
 * 'Screen Size': '1024x768',
 * 'Source': 'Member Search',
 * ~~~~
 *
 * Android Bike Client
 * ~~~~
 * 'Bike Frame Serial': 'T1710PL01059730',
 * 'OS Version': 11.3,
 * 'Touchscreen Generation': 'Ruby',
 * 'Touchscreen Serial': 'someSerialNumber',
 * 'Toggles': ['here_now', 'high_fives'],
 * 'Source': 'Profile'
 * ~~~~
 *
 * Android Tread Client
 * ~~~~
 * 'OS Version': 11.3
 * 'Touchscreen Generation': 'Ruby',
 * 'Touchscreen Serial': 'someSerialNumber',
 * 'MCB Serial': 'serialnumber',
 * 'Chassis Serial': 'serialnumber',
 * 'Smartcard Serial': 'serialnumber',
 * 'Toggles': ['here_now', 'high_fives'],
 * 'Source': 'Profile'
 * ~~~~
 *
 * iOS Client
 * ~~~~
 * 'Device Type': 'iPhone',
 * 'Device': 'iPhone X',
 * 'App Version': '8.6.0',
 * 'iOS Version': '10.0.2',
 * 'iOS Subscription ID': 'someIdNumber',
 * 'Source': 'Followers'
 * ~~~~
 *
 * @param pelotonPlatform Platform the endpoint is called on. This may hide information from the response (class types, fitness disciplines, classes of certain fitness disciplines, etc.) that should not display on this platform. If this has any other effect on the endpoint, it will be noted in the description.
 *
 * @param fitnessDiscipline Optional. Needed only when requiring filters for specific fitness discipline
 * @param includeIconImages True/False toggle to include new icon image urls in the response.  The currently supported filters with images affected by this toggle are:
 * counted in, weights yes, weights no, bookmarked, and taken by me.
 * Note, this parameter will have no effect on the instructor images. Instructor images  will be returned by the api regardless of the value of this parameter.
 * @returns ClassGroupFilterResponse A Collection filter response
 * @throws ApiError
 */

export var getClassGroupFilters = function getClassGroupFilters(api, pelotonClientDate, classGroupId, acceptLanguage, pelotonClientDetails, pelotonPlatform, fitnessDiscipline, includeIconImages) {
  var options = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : {};
  var localVarPath = "/api/class_group/".concat(classGroupId, "/filters");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof fitnessDiscipline !== 'undefined') {
    localVarQueryParameter['fitness_discipline'] = fitnessDiscipline;
  }

  if (typeof includeIconImages !== 'undefined') {
    localVarQueryParameter['include_icon_images'] = includeIconImages;
  }

  localVarHeaderParameter['Peloton-Client-Date'] = String(pelotonClientDate);
  localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
  localVarHeaderParameter['Peloton-Client-Details'] = String(pelotonClientDetails);
  localVarHeaderParameter['Peloton-Platform'] = String(pelotonPlatform);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};